// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://qosxlmrrkyvobjigsynt.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFvc3hsbXJya3l2b2JqaWdzeW50Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE5MTcwMjcsImV4cCI6MjA5NzQ5MzAyN30.RjJC-asmSFAXHavpzInlmL5By0V9_NgJjLxmKpCbJo4';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// storage omitted outside a real browser (e.g. Node-environment tests) — the
// auth client's own isBrowser() check then falls back to its in-memory adapter
// instead of throwing on a missing `localStorage` global.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    ...(typeof window !== 'undefined' ? { storage: localStorage } : {}),
    persistSession: true,
    autoRefreshToken: true,
  }
});